import { CreateIotDevicePayload } from '../../model/iot-device.model';

export class LoadDevices {
  static readonly type = '[Automation] Load Devices';
  constructor(
    readonly page: number,
    readonly maxResults: number,
  ) {}
}

export class CreateDevice {
  static readonly type = '[Automation] Create Device';
  constructor(readonly payload: CreateIotDevicePayload) {}
}

export class UpdateDevice {
  static readonly type = '[Automation] Update Device';
  constructor(
    readonly id: string,
    readonly payload: CreateIotDevicePayload,
  ) {}
}

export class DeleteDevice {
  static readonly type = '[Automation] Delete Device';
  constructor(readonly id: string) {}
}
